import { Component, OnInit, Renderer, Input } from '@angular/core';
import { DataService } from '../../services/data.service';
import { saveAs } from 'file-saver';

@Component({
    selector: 'videodetails',
    template: require('./videoDetails.html'),
    styles: [require('./videoDetails.css')]
})
export class VideoDetailsComponent implements OnInit {
    @Input() public details: string;
    @Input() public participant: string;
    @Input() public question: string;
    @Input() public activeRoute: string;
    @Input() public eventTitle: string;
    data: any;
    show = false;
    vMin = 0;
    vSec = 0;

    public downloadSelectedBtnText:string = 'Download Video';
    public downloadSelectedBtnDisabled:boolean = false;

    constructor(public dataService: DataService, public renderer: Renderer) {}

    ngOnInit() {
        try {
            this.data = JSON.parse(this.details);

            if (this.data.cuepoints) {
                this.data.annotations = this.data.cuepoints.map( cp => cp.time + ';' + cp.text + ';' + cp.detail).join('\n');
            }
        } catch(err) {
            console.error(err);
        }
    }

    formatTime(tm:any) {
        var vTime: any = (parseFloat(tm) / 60).toFixed(2).toString();
        var tmpTM: any;
        var tmpMM: any = 0;
        var tmpSS: any = 0;

        if(vTime.indexOf(".") > 0) {
            tmpTM = vTime.split(".");
            tmpMM = parseInt(tmpTM[0]);
            tmpSS = parseInt(tmpTM[1]);

            if(tmpSS > 60) {
                tmpMM++;
                tmpSS = tmpSS - 60;
            }
        } else {
            tmpSS = parseInt(vTime);

            if(tmpSS > 60) {
                tmpMM++;
                tmpSS = tmpSS - 60;
            }
        }

        if (tmpMM < 10) tmpMM = '0' + tmpMM; else vTime = tmpMM;
        if (tmpSS < 10) tmpSS = '0' + tmpSS; else vTime = tmpSS;

        return tmpMM + ':' + tmpSS;
    }

    showDetails() {
        this.show = true;
    }

    hideDetails() {
        this.show = false;
    }

    download() {
        // console.log('make download url for', this.data.name)
        this.downloadSelectedBtnText = 'Please Wait...';
        this.downloadSelectedBtnDisabled = true;
        let videos = {"videos":[{"archiveId":this.data.name}]};
        this.dataService.downloadVideo(this.activeRoute, this.eventTitle, JSON.stringify(videos)).subscribe(dwnload => {
            this.downloadSelectedBtnText = 'Download Video';
            this.downloadSelectedBtnDisabled = false;
            saveAs(dwnload, (this.participant + '__' + this.question).replace(/ /g, '-') + '__' + this.data.time.replace(/\.[0-9]{3}Z/,'Z') + ".mp4");
        });
    }

    copyAnnotation(e) {
        let textArea = document.querySelector('#annotations') as HTMLTextAreaElement;
        let button = document.querySelector('#copytoclipboard') as HTMLButtonElement;
        textArea.select();

        try {
            let successful = document.execCommand('copy');
            button.innerText = successful ? 'Copied' : 'Failed';
        } catch (err) {
            button.innerText = 'Fail';
            // console.log('Oops, unable to copy', err);
        }
        setTimeout(() => {
            button.innerText = 'Copy Annotation';
        }, 2000);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/viewsmodule/experienceReport/videoDetails.ts